export const GMAIL = 'gmail';
export const GOOGLE_CALENDAR = 'google_calendar';
export const MAC = 'macOS';
export const MOVES_APP = 'moves_app';
export const OFFICE365 = 'office365';
export const WINDOWS = 'Windows';
export const LINUX = 'Linux';
export const MEMORY_BROWSER_EXTENSION = 'browser_extension';
export const GITHUB = 'github';
export const TRELLO = 'trello';
export const ASANA = 'asana';
export const ASANA_SYNC = 'asana_sync';
export const WUNDERLIST = 'wunderlist';
export const TODOIST = 'todoist';
export const TOGGL = 'toggl';
export const HARVEST = 'harvest';
export const JIRA = 'jira';
export const TIMELY = 'timely';
export const PHONE_CALLS = 'phone_calls';
export const QUICKBOOKS = 'quick_books';
export const TIMELY_GPS_TRACKER = 'gps_tracker';
export const ZOOM = 'zoom';
export const OUTLOOK_MAIL = 'outlook_mail';
export const BASECAMP = 'basecamp3';
export const TEAMS = 'teams';
export const AZURE_AD = 'azure_ad';
export const ZAPIER = 'zapier';
export const MAKE = 'make';
export const CLICKUP = 'clickup';
export const MONDAY = 'monday';
export const GOOGLE_SHEETS = 'google_sheets';

export type AppId =
  | typeof GMAIL
  | typeof GOOGLE_CALENDAR
  | typeof MAC
  | typeof LINUX
  | typeof MEMORY_BROWSER_EXTENSION
  | typeof MOVES_APP
  | typeof OFFICE365
  | typeof WINDOWS
  | typeof GITHUB
  | typeof TRELLO
  | typeof ASANA
  | typeof ASANA_SYNC
  | typeof WUNDERLIST
  | typeof TODOIST
  | typeof TIMELY
  | typeof JIRA
  | typeof HARVEST
  | typeof TOGGL
  | typeof PHONE_CALLS
  | typeof QUICKBOOKS
  | typeof TIMELY_GPS_TRACKER
  | typeof ZOOM
  | typeof OUTLOOK_MAIL
  | typeof BASECAMP
  | typeof TEAMS
  | typeof CLICKUP
  | typeof MONDAY
  | typeof GOOGLE_SHEETS;

const knownApps = {
  gps: [MOVES_APP, TIMELY_GPS_TRACKER],
  trackers: [MAC, WINDOWS, LINUX, MEMORY_BROWSER_EXTENSION],
  calendar: [GOOGLE_CALENDAR, OFFICE365],
  // Add the rest as we support them
  integrations: [
    GMAIL,
    GITHUB,
    TRELLO,
    ASANA,
    WUNDERLIST,
    TODOIST,
    TOGGL,
    JIRA,
    HARVEST,
    QUICKBOOKS,
  ],
  memoryApps: [
    GOOGLE_CALENDAR,
    MOVES_APP,
    OFFICE365,
    MAC,
    WINDOWS,
    LINUX,
    GMAIL,
    TRELLO,
    ASANA,
    WUNDERLIST,
    GITHUB,
    TODOIST,
    PHONE_CALLS,
    TIMELY_GPS_TRACKER,
    ZOOM,
    OUTLOOK_MAIL,
    MEMORY_BROWSER_EXTENSION,
    BASECAMP,
    TEAMS,
  ],
  mobileApps: [TIMELY_GPS_TRACKER, PHONE_CALLS],
  trackerApps: [MAC, WINDOWS, LINUX, MEMORY_BROWSER_EXTENSION, TIMELY_GPS_TRACKER, PHONE_CALLS],
  onboardingList: [GMAIL, OFFICE365, GOOGLE_CALENDAR],
  timeTrackingIntegrations: [
    GMAIL,
    GOOGLE_CALENDAR,
    OFFICE365,
    OUTLOOK_MAIL,
    TRELLO,
    GITHUB,
    TODOIST,
    ASANA,
    ZOOM,
    JIRA,
    BASECAMP,
    TEAMS,
  ],
  syncIntegrations: [QUICKBOOKS, AZURE_AD, TOGGL, HARVEST, CLICKUP, MONDAY, ASANA_SYNC],
  reportingIntegrations: [GOOGLE_SHEETS],
  automations: [ZAPIER, MAKE],
} as const;

export default knownApps;

export const prereleaseApps = [LINUX];

/**
 * Simple data structure for beta apps:
 * - Apps with their key here are marked `beta` on the ecosystem page/in the app editor.
 * - Values contain the beta feedback survey link for that app, shown in the app editor.
 */
export const betaApps: Partial<Record<AppId, string>> = {
  [ASANA_SYNC]: 'https://form.typeform.com/to/yjqnQ6p2',
};
export const customOptionApps: Array<Partial<AppId>> = [CLICKUP, MONDAY, ASANA_SYNC] as const;

/** Apps that require workspace admin privileges to connect */
export const adminOnlyApps: ReadonlyArray<AppId> = [GOOGLE_SHEETS] as const;
